// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3xlac","list":"styles_list__3SNIg"};